export default "__VITE_ASSET__DHpCs6ux__"